import React from "react";
import { useMutation } from "react-query";
import { getModuleColumns } from "../../../../actions/Utilities/CustomReport";

const useGetModuleColumns = () => {
  return useMutation(getModuleColumns);
};
export default useGetModuleColumns;
